import { Divider } from 'antd';
import styled from 'styled-components';

export const OrderSummaryContainerStyled = styled.div``;

export const OrderSummaryBlockStyled = styled.div``;

export const OrderSummaryHeadingStyled = styled.h3`
	margin: 0;
`;

export const SummaryPriceContainerStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 4px 0;
`;

export const DividerStyled = styled(Divider)`
	margin: 12px 0;
`;

export const OrderSummaryUnitsContainerStyled = styled.div`
	gap: 2px;
	display: flex;
	flex-direction: column;
`;

export const OrderSummaryUnitsItemStyled = styled.p`
	margin: 0;
	color: #262626;
	font-weight: 400;
	font-size: 14px;
`;

export const OrderSummaryHeaderStyled = styled.div`
	gap: 16px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const OrderSummaryHeaderTextStyled = styled.h2`
	margin: 0;
	color: #262626;
	text-align: center;
	letter-spacing: -0.32px;
	font-weight: 600;
	font-style: normal;
	font-size: 20px;
	line-height: 24px;
`;

export const BlockContainerStyled = styled.div`
	margin: 24px 0 8px 0;
`;

export const TrialEndingDateStyled = styled.p`
	color: #595959;
	font-weight: 600;
	font-size: 16px;
`;

export const SummaryPriceHeadingStyled = styled.h3`
	gap: 8px;
	margin: 0;
	font-weight: 600;
	font-size: 16px;
`;

export const RolesInfoContainerStyled = styled.div`
	margin: 16px 0;
`;

export const UnitsInfoContainerStyled = styled.div`
	margin: 16px 0;
`;

export const OrderSummaryTextStyled = styled.p`
	margin: 0;
	color: #262626;
	letter-spacing: -0.15px;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	line-height: 22px;
`;

export const RolesListStyled = styled.ul`
	margin-top: 8px;
	padding-left: 20px;
`;

export const UnitsContainerStyled = styled.div`
	row-gap: 4px;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	align-items: flex-start;
	overflow-x: scroll;
	margin-top: 8px;
	width: 100%;
	height: 130px;
	column-gap: 24px;
`;

export const UnitsInfoHeaderStyled = styled.h2`
	color: #262626;
	letter-spacing: -0.32px;
	font-weight: 600;
	font-style: normal;
	font-size: 16px;
	line-height: 24px;
`;

export const PeriodContainerStyled = styled.div`
	margin: 16px 0;
`;

export const LinksContainerStyled = styled.div`
	gap: 8px;
	display: flex;
	flex-direction: column;
	margin: 16px 0;
`;

export const RolesListItemStyled = styled.li`
	color: #262626;
	letter-spacing: -0.15px;
	font-weight: 400;
	font-style: normal;
	font-size: 14px;
	line-height: 22px;
`;

export const SummaryInfoTextStyled = styled.p`
	margin-bottom: 12px;
	color: #262626;
	white-space: pre-wrap;
	font-weight: 400;
	font-size: 14px;
	line-height: 22px;
`;

export const OrderSummaryHeadingContainerStyled = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;
`;
